<h1 mat-dialog-title>{{ 'WL-CreateEmploymentConditionsConfirmationsDialogTitle' | translate }}</h1>

<div mat-dialog-content>
  <div>
    <p>{{ 'WL-CreateEmploymentConditionsConfirmationsSelectedAgreements' | translate: { agreementsCount: selectedWorkerAgreements } }}</p>
    <p>{{ 'WL-CreateEmploymentConditionsConfirmationsGeneratedFor' | translate: { agreementsCount: resultCounts[ConditionsConfirmationGenerationStatus.ReadyToGenerate] } }}</p>
    @if (resultCounts[ConditionsConfirmationGenerationStatus.AlreadyGenerated] > 0) {
      <p>
        {{ 'WL-CreateEmploymentConditionsConfirmationsWhenSomeAlreadyExistMessage' | translate: { agreementsCount: resultCounts[ConditionsConfirmationGenerationStatus.AlreadyGenerated] } }}
      </p>
    }
    @if (resultCounts[ConditionsConfirmationGenerationStatus.CannotGenerateForMandateAgreement] > 0) {
      <p>
        {{ 'WL-CreateEmploymentConditionsConfirmationsForMandateAgreement' | translate: { agreementsCount: resultCounts[ConditionsConfirmationGenerationStatus.CannotGenerateForMandateAgreement] } }}
      </p>
    }
    @if (resultCounts[ConditionsConfirmationGenerationStatus.CannotGenerateForImportedFromOtherSystems] > 0) {
      <p>
        {{ 'WL-CreateEmploymentConditionsConfirmationsImportedFromOtherSystem' | translate: { agreementsCount: resultCounts[ConditionsConfirmationGenerationStatus.CannotGenerateForImportedFromOtherSystems] } }}
      </p>
    }
    @if (resultCounts[ConditionsConfirmationGenerationStatus.CannotGenerateForNotSignByUser] > 0) {
      <p>
        {{ 'WL-CreateEmploymentConditionsConfirmationsForNotSignByUser' | translate: { agreementsCount: resultCounts[ConditionsConfirmationGenerationStatus.CannotGenerateForNotSignByUser] } }}
      </p>
    }
  </div>
</div>

<div mat-dialog-actions class="row">
  <div class="col">
    <button mat-raised-button class="float-left" color="accent" (click)="onDismiss()">{{ 'Cancel' | translate }}</button>
    <button mat-raised-button class="float-right" color="primary" (click)="onConfirm()">{{ 'Generate' | translate }}</button>
  </div>
</div>
